import { Injectable } from '@angular/core';
import { DashBoard } from './models/dashboard/dashboard.model';
import { ApiService } from './services/Common/api.service';
import { UrlHelperService } from './services/Common/urlhelper.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private _api: ApiService) { }

  GetOrdersTotal() {
    return this._api.get(UrlHelperService. getOrderTotal)
  }

  GetTotalAmountSpend() {
    return this._api.get(UrlHelperService. getTotalAmountSpend)
  }

  GetTotalOrderStatus(orderStatus: DashBoard){
    return this._api.post(UrlHelperService.getTotalOrderStatus, orderStatus)
  }

  GetActiveProductsTotal() {
    return this._api.get(UrlHelperService. getActiveProductTotal)
  }


  GetCategoryTotal() {
    return this._api.get(UrlHelperService. getCategoryTotal)
  }

  GetAdminOrderTotal() {
    return this._api.get(UrlHelperService. getAdminOrderTotal)
  }

  GetAdminEarning() {
    return this._api.get(UrlHelperService. getAdminEarning)
  }

  GetAdminOrderStatus(orderStatus: DashBoard){
    return this._api.post(UrlHelperService.getAdminOrderStatus,orderStatus)
  }

  getLatestOrdersAdmin() {
    return this._api.get(UrlHelperService.getAdminLatestOrders);
  }

  getLatestOrdersCustomer() {
    return this._api.get(UrlHelperService.getCustomerLatestOrders);
  }

  GetAdminWarrantyTotal() {
    return this._api.get(UrlHelperService. getAdminTotalWarranty)
  }

  GetCustomerWarrantyTotal() {
    return this._api.get(UrlHelperService. getCustomerTotalWarranty)
  }

  GetInActiveProductsTotal() {
    return this._api.get(UrlHelperService. getInActiveProductTotal)
  }

  GetAdminProductTotal() {
    return this._api.get(UrlHelperService. getProductTotal)
  }
}
